<template>
  <div class="reportMarkPage">
    <Row :gutter="24" class="pageContentWrap">
      <Col :span="6" class="leftContent">
        <h2 class="markTitle">报告修改痕迹</h2>
        <div class="reportItem" v-for="(item, index) in traceList" :key="item.id" :class="{activedReport: item.mark}" @click="selectTraceItem(item, index)">
          <div>修改时间：{{item.created_date}}</div>
          <div>编辑人：{{item.modifier | changeDoctorName('write')}}</div>
        </div>
      </Col>
      <Col :span="18" class="rightContent">
        <PrintTemplate :report="currentShowReport" v-if="currentShowReport.id"/>
        <List v-if="!prevReport.id">
          <ListItem v-for="(kong, index) in []" :key="index"></ListItem>
        </List>
      </Col>
    </Row>
  </div>
</template>
<script>
import { Col, Row, List } from 'ant-design-vue'
import PrintTemplate from '../../components/PrintTemplate'
import { getReportEditHistory } from '../../api/report'
import { getParamFromRoute } from '../../libs/utils'
import { diffChars } from 'diff'
export default {
  components: {
    Col,
    Row,
    PrintTemplate,
    List,
    ListItem: List.Item
  },
  data () {
    return {
      prevReport: {},
      traceList: [],
      currentShowReport: {}
    }
  },
  async mounted () {
    let routeParams = getParamFromRoute(this.$route)
    if (!routeParams.reportId) return this.$router.goBack()
    this.routeParams = routeParams
    await this.getTraceList()
  },
  methods: {
    async getTraceList () {
      let list = await getReportEditHistory({id: this.routeParams.reportId})
      if (list && list.length >= 1) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          if (i === 0) item.mark = true
          else item.mark = false
        }
        this.traceList = list
        this.selectTraceItem(list[0], 0)
      }
    },
    selectTraceItem (item, index) {
      for (let i = 0; i < this.traceList.length; i++) {
        let traceItem = this.traceList[i]
        traceItem.mark = false
      }
      item.mark = true
      this.currentShowReport = item
      if (index === this.traceList.length - 1) {
        this.prevReport = item
      } else {
        this.prevReport = this.traceList[index + 1]
      }
      this.$nextTick(() => {
        this.diffContent()
      })
    },
    diffContent () {
      let representDom = document.getElementById('reportRepresent')
      let fragmentOne = document.createDocumentFragment()
      let dianoseDom = document.getElementById('reportDiagnose')
      let fragmentTwo = document.createDocumentFragment()
      let diffRepresentation = diffChars(this.prevReport.image_representation || '', this.currentShowReport.image_representation || '')
      let diffDiagnose = diffChars(this.prevReport.diagnostic_result || '', this.currentShowReport.diagnostic_result || '')
      diffRepresentation.forEach((part) => {
        let color = part.added ? 'green' : part.removed ? 'red' : 'grey'
        let span = document.createElement('span')
        span.style.color = color
        span.appendChild(document.createTextNode(part.value))
        fragmentOne.appendChild(span)
      })
      while (representDom.firstChild) {
        representDom.removeChild(representDom.firstChild)
      }
      while (dianoseDom.firstChild) {
        dianoseDom.removeChild(dianoseDom.firstChild)
      }
      diffDiagnose.forEach((part) => {
        let color = part.added ? 'green' : part.removed ? 'red' : 'grey'
        let span = document.createElement('span')
        span.style.color = color
        span.appendChild(document.createTextNode(part.value))
        fragmentTwo.appendChild(span)
      })
      representDom.appendChild(fragmentOne)
      dianoseDom.appendChild(fragmentTwo)
    }
  }
}
</script>
<style lang="less">
@import '../../style/common/mixin.less';
@import '../../style/common/variable.less';
// 隐藏头部
.hiddenHeader();
.reportMarkPage{
  height: 100%;
  .pageContentWrap{
    height: 100%;
    .leftContent{
      height: 100%;
      overflow-y: auto;
      background: @baseColor;
      padding: 0 0 0 10px !important;
      .markTitle{
        padding: 16px 24px;
        border-bottom: 1px solid @divideLineColor;
        margin-bottom: 0;
      }
      .reportItem{
        padding: 16px 24px;
        border-bottom: 1px solid @divideLineColor;
      }
      .activedReport{
        background-color: @primaryColor;
        color:@baseColor;
      }
    }
    .rightContent{
      height: 100%;
      overflow-y: auto;
      padding: 40px 40px !important;
      .printTempComponent{
        width: calc(21cm + 60px);
      }
    }
  }
}
</style>